import { trackInitiateCheckout } from './metaPixel'

export const CHECKOUT_URLS = {
  fq: 'https://profelisto.com.ar/checkouts/cn/hWNCOc821VkvJWPbfDO38zYY/es-ar?_r=AQAB-1x1gVqp7fMEtfGdiDAUqu1Rt3DhvK0Bu26S9jWTCMQ',
  megapack:
    'https://profelisto.com.ar/checkouts/cn/hWNCOc8Iw0lruPIEhlLw7UEU/es-ar?_r=AQAB7ZiFr2Db5b_wt4B8t-pf00RHgGuj_cEjoR6uNwfOByg',
} as const

export const goToCheckout = (variant: 'fq' | 'megapack') => {
  trackInitiateCheckout(variant)
  window.location.href = CHECKOUT_URLS[variant]
}
